import { Component, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { MenuService } from '../service/menu.service';
import { UserService } from '../service/user.service';
import { tabsMockData } from '../../data/tabData';
import { AlertPopupComponent } from '../pages/popups/alert-popup/alert-popup.component';


@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule,AlertPopupComponent],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {
  role:any
  selectedTab?: string;
  selectedSidebar!: string;
  clraType:any
  showTabs: boolean = true;
  alertData = { alertMessage: '', alertVisible: '' };
  mockTabs:any = []
  selectedModuleName:string = ''

  constructor(
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly menuService: MenuService,
    private readonly user:UserService
  ) { }


  navigateToMock(component: string) {
    if ((component == 'CommercialMapping' || component == 'StateBillingMaster' || component == 'PO') && sessionStorage.getItem('isScopingCompleted') == '0') {
      this.alertData = {
        alertMessage: 'Please fill all scoping details before proceeding',
        alertVisible: 'error'
      };
      return;
    }
    if ((component == 'StateBillingMaster' || component == 'PO') && sessionStorage.getItem('IsCommercialPresent') == '0') {
      this.alertData = {
        alertMessage: 'Please complete all the pricing status before proceeding to the state billing master',
        alertVisible: 'error'
      };
      return;
    }
    if ((component == 'PO') && sessionStorage.getItem('IsStateBillingPresent') == '0') {
      this.alertData = {
        alertMessage: 'Please fill at least one State billing before proceeding',
        alertVisible: 'error'
      };
      return;
    }
    this.selectedTab = component
    this.router.navigate([`/${component}`]);  
  }

  isTabSelectedMock(component: string): boolean {
    return this.selectedTab === component;
  }

  ngOnInit(): void {
    this.role=this.user.getRole()
    if (this.user.getClientId()) {
      this.getClraType();
    }

    this.menuService.selectedMenu$.subscribe((menu) => {
      this.selectedSidebar = menu || '';
      this.mockTabs = tabsMockData?.filter(value => value?.role === this.user.getRole() && value?.module === this.selectedSidebar)[0]?.tabs
      // this.selectedTab = this.mockTabs[0]?.component;
      this.selectedTab = this.mockTabs.find((t: any) =>
        t.component.toLowerCase() === this.router.url.split('/').pop()?.toLowerCase()
      )?.component || this.mockTabs[0]?.component;

      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.selectedTab = event.urlAfterRedirects.slice(1)
          this.showTabs = !(event.urlAfterRedirects.includes('PremiseAddEdit') || event.urlAfterRedirects.includes('LocationAddEdit') || event.urlAfterRedirects.includes('ContractorAddEdit') || event.urlAfterRedirects.includes('PremiseBulkUpload') || event.urlAfterRedirects.includes('RegistrationRepositoryAddEdit') || event.urlAfterRedirects.includes('ListofHolidaysNotifications'));
        }
      })
    });

  }

  getClraType(){
    // const clientId=this.user.getClientId()
    // this.PEService.getClraType(clientId).subscribe({
    //   next:(response)=>{
    //     const data=response.body.result;
    //     this.clraType=data;

    //   }
    // })
  }

  // fetchTabs(menu: string): void {
  //   this.tabsService.getTabsDetails(menu).subscribe({
  //     next: (response) => {
  //       if (response) {
  //         this.tabs = response.body;
  //         this.sortedTabs = this.tabs
  //           .filter(tab => {
  //             if ((this.role === 'PERF' || this.role==='RVW1') && this.selectedSidebar === 'Onboard Entity' ) {
  //               return tab.tabName === 'Premises' || tab.tabName === 'User-Branch Mapping';
  //             }
  //             return true;
  //           })
  //           .sort((a, b) => a.sort_order - b.sort_order)
  //           .filter((tab) => {
  //             return !(this.selectedSidebar === 'Onboard CLRA' && this.clraType === 'CAP' && tab.tabName === 'Employee Mapping');
  //           });
  
 
  //         const initialTab = this.tabs.find(tab => tab.routePath === this.router.url);
  //         if (initialTab) {
  //           this.selectedTab = initialTab.tabName;
  //           this.applySelectedTabClass();
  //         }
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching Tabs data', error);
  //     }
  //   });
  // }
  

  // navigateTo(tab: Tab): void {
  //   this.selectedTab = tab.tabName;
  //   this.router.navigate([tab.routePath]);
  //   this.applySelectedTabClass();  
  // }

  // isTabSelected(tab: Tab): boolean {
  //   return this.selectedTab === tab.tabName;
    
    
  // }



  applySelectedTabClass(): void {
    setTimeout(() => { 
      const elements = document.querySelectorAll('.listItem');
      elements.forEach((element: Element) => {
        if (element.innerHTML.includes(this.selectedTab ?? '')) {
          this.renderer.addClass(element, 'selected-tab');
        } else {
          this.renderer.removeClass(element, 'selected-tab');
        }
      });
    }, 0);
  }
   closeAlert() {
    this.alertData = { alertMessage: '', alertVisible: '' };
  }
}
